import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getObjValue',
  standalone: false,
})
export class GetObjValuePipe implements PipeTransform {
  public transform<T>(obj: any, key: string): any {
    return obj[key];
  }
}
